define(function (require, exports, module) {
    'use strict';

    exports.retail = require('./retail');
});



//////////////////
// WEBPACK FOOTER
// ./scripts/main.js
// module id = 1
// module chunks = 0